import React from 'react';
import { Button, Dropdown } from 'antd';
import { CalculatorOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import type { WZBatchConversionTarget } from '../wzBatchQuantityConversion';

interface Props {
  onConvert: (target: WZBatchConversionTarget) => void;
  disabled?: boolean;
}

const WZBatchConversionMenu: React.FC<Props> = ({ onConvert, disabled = false }) => {
  const { t } = useTranslation(['wz']);

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: [
          { key: 'pcs', label: t('wz:createForm.batchToPcs') },
          { key: 'm2', label: t('wz:createForm.batchToM2') },
          { key: 'm3', label: t('wz:createForm.batchToM3') },
        ],
        onClick: ({ key }) => onConvert(key as WZBatchConversionTarget),
      }}
    >
      <Button icon={<CalculatorOutlined />} disabled={disabled}>
        {t('wz:createForm.batchConversion')}
      </Button>
    </Dropdown>
  );
};

export default WZBatchConversionMenu;
